// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
require('./assets/fonts/siconfont');
import 'babel-polyfill';
import Vue from 'vue';
import VueLazyload from 'vue-lazyload';
import Util from './_utils/util';
import Subject from './Subject.vue';

Vue.config.productionTip = false;
Vue.use(VueLazyload, {
  preLoad: 1.1,
  error: '//47f72d130392f.cdn.sohucs.com/web/static/images/pic/preload.png',
  loading: '//47f72d130392f.cdn.sohucs.com/web/static/images/pic/preload.png',
  attempt: 2,
  filter: {
      progressive(listener, options) {
          const isCDN = /qiniudn.com/
          if (isCDN.test(listener.src)) {
              listener.el.setAttribute('lazy-progressive', 'true')
              listener.loading = listener.src + '?imageView2/1/w/10/h/10'
          }
      },
      webp(listener, options) {
          let imgUrl = listener.src;
          if(imgUrl){//是否前端开启替换图片尺寸
              imgUrl = imgUrl.replace('c_fill,w_150,h_100,g_faces,q_70','c_fill,w_300,h_200,g_faces,q_70');
          }
          const webPPicReg = /\.webp$/i,
          gifPicReg = /\.gif$/i,
          picReg = /\.(jpg|jpeg|png)$/i;
          const isCDN = /.*(5b0988e595225.cdn.sohucs.com|29e5534ea20a8.cdn.sohucs.com|img.mp.itc.cn|img.mp.sohu.com).+/i;
          if (isCDN.test(listener.src)) {
              if(!imgUrl.match(webPPicReg)){
                  if(imgUrl.match(gifPicReg)){
                      listener.src = imgUrl.replace(gifPicReg, '.jpg');
                  }else{
                      if (!options.supportWebp) return;
                      listener.src = imgUrl.replace(picReg, '.webp');
                  }
              }
          }
      }
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: { Subject }
});
window.onload = function(){
    //触发统计sdk的埋点
    if(window.sohuSpm && typeof window.sohuSpm.domDidChange === 'function') {
        window.sohuSpm.domDidChange();
    };
}


// WEBPACK FOOTER //
// ./src/main.js